var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowingClearFilters)?_c('button',{staticClass:"text-secondary",attrs:{"type":"button"},on:{"click":_vm.clearFilters}},[_vm._v("\n  Clear filters\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }